export const UNREGISTERED_MOTO = {
  nickname: 'PRODUCTS.UNREGISTERED_MOTO.nickname'
};
